var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSchedule = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "schedule"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_0_187",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Bounding box",
  width: 20,
  height: 20,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_0_187)"
}, /*#__PURE__*/React.createElement("path", {
  id: "schedule_2",
  d: "M10.8333 9.66667V6.66667C10.8333 6.43056 10.7535 6.23264 10.5938 6.07292C10.434 5.91319 10.2361 5.83333 10 5.83333C9.76389 5.83333 9.56597 5.91319 9.40625 6.07292C9.24653 6.23264 9.16667 6.43056 9.16667 6.66667V9.97917C9.16667 10.0903 9.1875 10.1979 9.22917 10.3021C9.27083 10.4062 9.33333 10.5 9.41667 10.5833L12.1667 13.3333C12.3194 13.4861 12.5139 13.5625 12.75 13.5625C12.9861 13.5625 13.1806 13.4861 13.3333 13.3333C13.4861 13.1806 13.5625 12.9861 13.5625 12.75C13.5625 12.5139 13.4861 12.3194 13.3333 12.1667L10.8333 9.66667ZM10 18.3333C8.84722 18.3333 7.76389 18.1146 6.75 17.6771C5.73611 17.2396 4.85417 16.6458 4.10417 15.8958C3.35417 15.1458 2.76042 14.2639 2.32292 13.25C1.88542 12.2361 1.66667 11.1528 1.66667 10C1.66667 8.84722 1.88542 7.76389 2.32292 6.75C2.76042 5.73611 3.35417 4.85417 4.10417 4.10417C4.85417 3.35417 5.73611 2.76042 6.75 2.32292C7.76389 1.88542 8.84722 1.66667 10 1.66667C11.1528 1.66667 12.2361 1.88542 13.25 2.32292C14.2639 2.76042 15.1458 3.35417 15.8958 4.10417C16.6458 4.85417 17.2396 5.73611 17.6771 6.75C18.1146 7.76389 18.3333 8.84722 18.3333 10C18.3333 11.1528 18.1146 12.2361 17.6771 13.25C17.2396 14.2639 16.6458 15.1458 15.8958 15.8958C15.1458 16.6458 14.2639 17.2396 13.25 17.6771C12.2361 18.1146 11.1528 18.3333 10 18.3333ZM10 16.6667C11.8472 16.6667 13.4201 16.0174 14.7187 14.7187C16.0174 13.4201 16.6667 11.8472 16.6667 10C16.6667 8.15278 16.0174 6.57986 14.7187 5.28125C13.4201 3.98264 11.8472 3.33333 10 3.33333C8.15278 3.33333 6.57986 3.98264 5.28125 5.28125C3.98264 6.57986 3.33333 8.15278 3.33333 10C3.33333 11.8472 3.98264 13.4201 5.28125 14.7187C6.57986 16.0174 8.15278 16.6667 10 16.6667Z",
  fill: "#1C1B1F"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSchedule);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule.1fa1b7481a5e5ded4fe6c0f19f3a82de.svg";